<div class="board-focus-body">
  @for (item of $items(); track item._id) {
    <entity-card [attr.data-board-row-id]="item._id" [item]="item" [metadata]="$metadata()" [card]="$cardConfig()" [clickable]="true" [selected]="isItemFocused(item)" (click)="onItemFocused(item)" />
  } @empty {
    <div class="board-focus-empty">No items</div>
  }
</div>

<div class="board-focus-footer">
  <ng-content select="[board-focus-footer]" />
</div>
